exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".controls-button {\n    color: #FFF;\n    background-color: rgba(0, 0, 0, 0);\n    box-sizing: border-box;\n    border-width: 0;\n    padding: 0.45rem;\n    font-size: 1rem;\n    cursor: pointer;\n}\n\n.controls-button:focus, .controls-button *:focus {\n    outline-style: none;\n}\n", ""]);

